import { useRef } from "react";
import { Link } from "react-router-dom";
import { works } from "@/mocks/works";
import WorkCard from "@/components/feature/WorkCard";

const railWorks = [...works].sort((a, b) => b.heat - a.heat).slice(0, 8);

export default function WorksRail() {
  const railRef = useRef<HTMLDivElement>(null);

  const scrollBy = (dir: 1 | -1) => {
    if (!railRef.current) return;
    const amount = railRef.current.clientWidth * 0.8;
    railRef.current.scrollBy({ left: dir * amount, behavior: "smooth" });
  };

  return (
    <div>
      <div className="mb-5 flex items-end justify-between gap-4">
        <div>
          <div className="mb-2 flex items-center gap-2">
            <span className="h-1 w-6 rounded-full bg-accent-500" />
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-600">Latest Works</span>
          </div>
          <h2 className="text-2xl font-bold text-foreground-950 md:text-3xl">最新影视作品推荐</h2>
          <p className="mt-1.5 text-sm text-foreground-600">按热度精选，左右滑动查看更多作品</p>
        </div>
        <div className="hidden items-center gap-2 sm:flex">
          <button
            type="button"
            onClick={() => scrollBy(-1)}
            aria-label="向左浏览"
            className="flex h-10 w-10 items-center justify-center rounded-full border border-background-300 text-xl text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
          >
            <i className="ri-arrow-left-s-line"></i>
          </button>
          <button
            type="button"
            onClick={() => scrollBy(1)}
            aria-label="向右浏览"
            className="flex h-10 w-10 items-center justify-center rounded-full border border-background-300 text-xl text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
          >
            <i className="ri-arrow-right-s-line"></i>
          </button>
          <Link
            to="/works"
            className="ml-2 inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700"
          >
            全部作品
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>

      <div
        ref={railRef}
        className="rail-scroll -mx-4 flex snap-x snap-mandatory gap-4 overflow-x-auto px-4 pb-4 md:mx-0 md:px-0"
      >
        {railWorks.map((work) => (
          <div key={work.id} className="w-[160px] shrink-0 snap-start sm:w-[180px] md:w-[196px]">
            <WorkCard work={work} />
          </div>
        ))}
      </div>

      <Link
        to="/works"
        className="mt-4 inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700 sm:hidden"
      >
        查看全部作品
        <i className="ri-arrow-right-line"></i>
      </Link>
    </div>
  );
}